import React, { useEffect, useState } from 'react';
interface Finding {
  detail: string;
  pattern: string;
  meaning: string;
  treatmentPoints: string;
  singlePoint: string;
}
interface Category {
  name: string;
  id: string;
  findings: Finding[];
}
const categories: Category[] = [{
  name: 'Body Colour',
  id: 'body-colour',
  findings: [{
    detail: 'Pale & slightly wet',
    pattern: 'Cold, Yang Qi Xu',
    meaning: 'Low Yang energy',
    treatmentPoints: '⬆️ CV4 (Guanyuan) 🔥<br>⬆️ DU4 (Mingmen) 🔥<br>⬆️ ST36 (Zusanli) 🔥<br>⬆️ BL23 (Shenshu) 🔥',
    singlePoint: '⬆️ CV4 (Guanyuan) 🔥'
  }, {
    detail: 'Pale & slightly dry',
    pattern: 'Cold, Xue Xu',
    meaning: 'Blood deficiency',
    treatmentPoints: '⬆️ SP6 (Sanyinjiao)<br>⬆️ ST36 (Zusanli)<br>⬆️ LV8 (Ququan)<br>⬆️ BL17 (Geshu) 🔥',
    singlePoint: '⬆️ SP6 (Sanyinjiao)'
  }, {
    detail: 'Pale on the sides',
    pattern: 'Liver Xue Xu',
    meaning: 'Liver blood deficiency',
    treatmentPoints: '⬆️ SP6 (Sanyinjiao)<br>⬆️ ST36 (Zusanli)<br>⬆️ LV8 (Ququan)<br>⬆️ BL18 (Ganshu)',
    singlePoint: '⬆️ LV8 (Ququan)'
  }, {
    detail: 'Orangey sides',
    pattern: 'Severe Liver Xue Xu',
    meaning: 'Advanced liver deficiency',
    treatmentPoints: '⬆️ SP6 (Sanyinjiao)<br>⬆️ ST36 (Zusanli)<br>⬆️ LV8 (Ququan)<br>⬆️ BL17 (Geshu) 🔥<br>⬆️ BL18 (Ganshu) 🔥',
    singlePoint: '⬆️ BL17 (Geshu) 🔥'
  }, {
    detail: 'Red',
    pattern: 'Heat',
    meaning: 'Heat syndrome',
    treatmentPoints: '⬇️ LI11 (Quchi)<br>⬇️ ST44 (Neiting)<br>⬇️ DU14 (Dazhui)',
    singlePoint: '⬇️ LI11 (Quchi)'
  }, {
    detail: 'Red w/ coating',
    pattern: 'Full Heat',
    meaning: 'Excess heat',
    treatmentPoints: '⬇️ LI11 (Quchi)<br>⬇️ ST44 (Neiting)<br>⬇️ PC3 (Quze)',
    singlePoint: '⬇️ LI11 (Quchi)'
  }, {
    detail: 'Red, no coating',
    pattern: 'Empty Heat',
    meaning: 'Yin deficiency, empty heat',
    treatmentPoints: '⬆️ KI3 (Taixi)<br>⬆️ SP6 (Sanyinjiao)<br>⬆️ KI6 (Zhaohai)<br>⬇️ LI11 (Quchi)',
    singlePoint: '⬆️ KI3 (Taixi)'
  }, {
    detail: 'Red tip w/ coating',
    pattern: 'Heart Fire',
    meaning: 'Heart fire',
    treatmentPoints: '⬇️ HT8 (Shaofu)<br>⬇️ HT3 (Shaohai)<br>⬇️ PC8 (Laogong)<br>⬆️ PC7 (Daling)',
    singlePoint: '⬇️ HT8 (Shaofu)'
  }, {
    detail: 'Red tip, no coating',
    pattern: 'Heart empty heat',
    meaning: 'Heart Yin deficiency',
    treatmentPoints: '⬆️ HT7 (Shenmen)<br>⬆️ PC7 (Daling)<br>⬆️ KI6 (Zhaohai)<br>⬆️ SP6 (Sanyinjiao)',
    singlePoint: '⬆️ HT7 (Shenmen)'
  }, {
    detail: 'Red sides w/ coating',
    pattern: 'Liver Fire/GB Heat',
    meaning: 'Liver/Gallbladder heat',
    treatmentPoints: '⬇️ GB34 (Yanglingquan)<br>⬇️ LV2 (Xingjian)<br>⬇️ LV3 (Taichong)',
    singlePoint: '⬇️ GB34 (Yanglingquan)'
  }, {
    detail: 'Red sides, no coating',
    pattern: 'Liver empty heat/Yin def',
    meaning: 'Liver heat/Yin deficiency',
    treatmentPoints: '⬆️ KI3 (Taixi)<br>⬆️ LV8 (Ququan)<br>⬆️ SP6 (Sanyinjiao)<br>⬇️ LV3 (Taichong)',
    singlePoint: '⬆️ LV8 (Ququan)'
  }, {
    detail: 'Red centre w/ coating',
    pattern: 'Heat in ST',
    meaning: 'Stomach heat',
    treatmentPoints: '⬇️ ST36 (Zusanli)<br>⬇️ ST44 (Neiting)<br>⬇️ ST34 (Liangqiu)',
    singlePoint: '⬇️ ST44 (Neiting)'
  }, {
    detail: 'Red centre, no coating',
    pattern: 'Empty heat in ST',
    meaning: 'Stomach Yin deficiency',
    treatmentPoints: '⬆️ ST36 (Zusanli)<br>⬆️ SP6 (Sanyinjiao)<br>⬆️ KI3 (Taixi)<br>⬆️ CV12 (Zhongwan)',
    singlePoint: '⬆️ ST36 (Zusanli)'
  }, {
    detail: 'Red points on tip',
    pattern: 'Heart Fire',
    meaning: 'Heart fire',
    treatmentPoints: '⬇️ HT8 (Shaofu)<br>⬇️ HT3 (Shaohai)<br>⬇️ PC8 (Laogong)<br>⬆️ PC7 (Daling)',
    singlePoint: '⬇️ HT8 (Shaofu)'
  }, {
    detail: 'Red points on sides',
    pattern: 'Liver Fire',
    meaning: 'Liver fire',
    treatmentPoints: '⬇️ LV2 (Xingjian)<br>⬇️ LV3 (Taichong)<br>⬇️ GB34 (Yanglingquan)',
    singlePoint: '⬇️ LV2 (Xingjian)'
  }, {
    detail: 'Red spots on root',
    pattern: 'Heat in lower jiao',
    meaning: 'Pelvic organ heat',
    treatmentPoints: '⬇️ LI11 (Quchi)<br>⬇️ SP6 (Sanyinjiao)<br>⬇️ CV3 (Zhongji)<br>⬇️ ST28 (Shuidao)',
    singlePoint: '⬇️ SP6 (Sanyinjiao)'
  }, {
    detail: 'Purple',
    pattern: 'Blood stasis',
    meaning: 'Blood stagnation',
    treatmentPoints: '⬇️ SP10 (Xuehai)<br>⬇️ LV3 (Taichong)<br>⬇️ PC6 (Neiguan)<br>⬇️ SP4 (Gongsun)',
    singlePoint: '⬇️ SP10 (Xuehai)'
  }, {
    detail: 'Reddish purple',
    pattern: 'Heat+Blood stasis',
    meaning: 'Stagnation with heat',
    treatmentPoints: '⬇️ SP10 (Xuehai)<br>⬇️ LV3 (Taichong)<br>⬇️ LI11 (Quchi)<br>⬇️ PC6 (Neiguan)',
    singlePoint: '⬇️ SP10 (Xuehai)'
  }, {
    detail: 'Bluish purple',
    pattern: 'Cold+Blood stasis',
    meaning: 'Stagnation with cold',
    treatmentPoints: '⬇️ SP10 (Xuehai)<br>⬇️ LV3 (Taichong)<br>⬆️ CV4 (Guanyuan) 🔥<br>⬇️ PC6 (Neiguan)',
    singlePoint: '⬇️ SP10 (Xuehai)'
  }]
}, {
  name: 'Body Shape',
  id: 'body-shape',
  findings: [{
    detail: 'Thin-red',
    pattern: 'Yin deficiency',
    meaning: 'Yin fluids deficiency',
    treatmentPoints: '⬆️ KI3 (Taixi)<br>⬆️ SP6 (Sanyinjiao)<br>⬆️ KI6 (Zhaohai)<br>⬆️ ST36 (Zusanli)',
    singlePoint: '⬆️ KI3 (Taixi)'
  }, {
    detail: 'Thin-pale',
    pattern: 'Blood deficiency',
    meaning: 'Deficient blood',
    treatmentPoints: '⬆️ SP6 (Sanyinjiao)<br>⬆️ ST36 (Zusanli)<br>⬆️ BL17 (Geshu) 🔥<br>⬆️ LV8 (Ququan)',
    singlePoint: '⬆️ ST36 (Zusanli)'
  }, {
    detail: 'Swollen',
    pattern: 'Dampness, phlegm',
    meaning: 'Fluid retention',
    treatmentPoints: '⬆️ SP9 (Yinlingquan)<br>⬆️ ST36 (Zusanli)<br>⬆️ CV9 (Shuifen) 🔥<br>⬆️ BL22 (Sanjiaoshu) 🔥',
    singlePoint: '⬆️ SP9 (Yinlingquan)'
  }, {
    detail: 'Swollen (red tip)',
    pattern: 'Heart Fire',
    meaning: 'Heart fire',
    treatmentPoints: '⬇️ HT8 (Shaofu)<br>⬇️ PC8 (Laogong)<br>⬆️ SP9 (Yinlingquan)<br>⬆️ PC7 (Daling)',
    singlePoint: '⬇️ HT8 (Shaofu)'
  }, {
    detail: 'Swollen (red sides)',
    pattern: 'Liver Fire',
    meaning: 'Liver fire',
    treatmentPoints: '⬇️ LV2 (Xingjian)<br>⬇️ LV3 (Taichong)<br>⬆️ SP9 (Yinlingquan)<br>⬇️ GB34 (Yanglingquan)',
    singlePoint: '⬇️ LV2 (Xingjian)'
  }, {
    detail: 'Swollen sides (pale center)',
    pattern: 'Spleen Deficiency',
    meaning: 'Spleen deficiency',
    treatmentPoints: '⬆️ ST36 (Zusanli)<br>⬆️ SP6 (Sanyinjiao)<br>⬆️ CV12 (Zhongwan) 🔥<br>⬆️ BL20 (Pishu) 🔥',
    singlePoint: '⬆️ ST36 (Zusanli)'
  }, {
    detail: 'Stiff',
    pattern: 'Wind/Xue stasis',
    meaning: 'Wind or blood stasis',
    treatmentPoints: '⬇️ LV3 (Taichong)<br>⬇️ GB20 (Fengchi)<br>⬇️ SP10 (Xuehai)<br>⬇️ LI4 (Hegu)',
    singlePoint: '⬇️ GB20 (Fengchi)'
  }, {
    detail: 'Flaccid',
    pattern: 'Jin-Ye Xu',
    meaning: 'Fluids deficiency',
    treatmentPoints: '⬆️ KI3 (Taixi)<br>⬆️ SP6 (Sanyinjiao)<br>⬆️ ST36 (Zusanli)<br>⬆️ CV4 (Guanyuan)',
    singlePoint: '⬆️ KI3 (Taixi)'
  }, {
    detail: 'Long',
    pattern: 'Heat',
    meaning: 'Internal heat',
    treatmentPoints: '⬇️ LI11 (Quchi)<br>⬇️ ST44 (Neiting)<br>⬇️ DU14 (Dazhui)',
    singlePoint: '⬇️ LI11 (Quchi)'
  }, {
    detail: 'Short (pale/wet)',
    pattern: 'Internal cold',
    meaning: 'Internal cold',
    treatmentPoints: '⬆️ CV4 (Guanyuan) 🔥<br>⬆️ DU4 (Mingmen) 🔥<br>⬆️ ST36 (Zusanli) 🔥<br>⬆️ BL23 (Shenshu) 🔥',
    singlePoint: '⬆️ CV4 (Guanyuan) 🔥'
  }, {
    detail: 'Short (red)',
    pattern: 'Severe Yin Deficiency',
    meaning: 'Severe deficiency',
    treatmentPoints: '⬆️ KI3 (Taixi)<br>⬆️ SP6 (Sanyinjiao)<br>⬆️ KI6 (Zhaohai)<br>⬆️ ST36 (Zusanli)',
    singlePoint: '⬆️ KI3 (Taixi)'
  }, {
    detail: 'Cracked (center/sides)',
    pattern: 'ST/SP Yin Deficiency',
    meaning: 'Stomach/Spleen depletion',
    treatmentPoints: '⬆️ ST36 (Zusanli)<br>⬆️ SP6 (Sanyinjiao)<br>⬆️ KI3 (Taixi)<br>⬆️ CV12 (Zhongwan)',
    singlePoint: '⬆️ ST36 (Zusanli)'
  }, {
    detail: 'Cracked (tip)',
    pattern: 'Heart Pattern',
    meaning: 'Heart syndrome',
    treatmentPoints: '⬆️ HT7 (Shenmen)<br>⬆️ PC7 (Daling)<br>⬆️ KI6 (Zhaohai)<br>⬆️ SP6 (Sanyinjiao)',
    singlePoint: '⬆️ HT7 (Shenmen)'
  }, {
    detail: 'Quivering',
    pattern: 'Spleen Deficiency',
    meaning: 'Spleen Qi weakness',
    treatmentPoints: '⬆️ ST36 (Zusanli)<br>⬆️ SP6 (Sanyinjiao)<br>⬆️ CV12 (Zhongwan) 🔥<br>⬆️ BL20 (Pishu) 🔥',
    singlePoint: '⬆️ ST36 (Zusanli)'
  }, {
    detail: 'Deviated',
    pattern: 'Internal Wind',
    meaning: 'Wind syndrome',
    treatmentPoints: '⬇️ GB20 (Fengchi)<br>⬇️ LV3 (Taichong)<br>⬇️ LI4 (Hegu)<br>⬇️ DU20 (Baihui)',
    singlePoint: '⬇️ GB20 (Fengchi)'
  }, {
    detail: 'Tooth marks (sides)',
    pattern: 'Spleen Qi Deficiency',
    meaning: 'Spleen Qi deficiency',
    treatmentPoints: '⬆️ ST36 (Zusanli)<br>⬆️ SP6 (Sanyinjiao)<br>⬆️ CV12 (Zhongwan) 🔥<br>⬆️ BL20 (Pishu) 🔥',
    singlePoint: '⬆️ ST36 (Zusanli)'
  }]
}, {
  name: 'Coating',
  id: 'coating',
  findings: [{
    detail: 'Thin & white (normal)',
    pattern: 'Normal',
    meaning: 'Healthy coating',
    treatmentPoints: 'No treatment needed<br>Maintain health',
    singlePoint: 'N/A'
  }, {
    detail: 'Thick',
    pattern: 'Pathogenic factor',
    meaning: 'Strong PF, damp, phlegm',
    treatmentPoints: '⬆️ SP9 (Yinlingquan)<br>⬆️ ST36 (Zusanli)<br>⬆️ CV12 (Zhongwan)<br>⬆️ ST40 (Fenglong)',
    singlePoint: '⬆️ ST40 (Fenglong)'
  }, {
    detail: 'No root',
    pattern: 'ST Qi Deficiency',
    meaning: 'Stomach Qi deficiency',
    treatmentPoints: '⬆️ ST36 (Zusanli)<br>⬆️ CV12 (Zhongwan) 🔥<br>⬆️ BL21 (Weishu)<br>⬆️ PC6 (Neiguan)',
    singlePoint: '⬆️ ST36 (Zusanli)'
  }, {
    detail: 'Absent coating',
    pattern: 'ST/Yin deficiency',
    meaning: 'Severe Yin deficiency',
    treatmentPoints: '⬆️ KI3 (Taixi)<br>⬆️ SP6 (Sanyinjiao)<br>⬆️ ST36 (Zusanli)<br>⬆️ KI6 (Zhaohai)',
    singlePoint: '⬆️ SP6 (Sanyinjiao)'
  }, {
    detail: 'White coating',
    pattern: 'Cold',
    meaning: 'Internal cold',
    treatmentPoints: '⬆️ CV4 (Guanyuan) 🔥<br>⬆️ ST36 (Zusanli) 🔥<br>⬆️ BL20 (Pishu) 🔥',
    singlePoint: '⬆️ CV4 (Guanyuan) 🔥'
  }, {
    detail: 'Grey/black coating',
    pattern: 'Extreme cold',
    meaning: 'Severe cold',
    treatmentPoints: '⬆️ CV4 (Guanyuan) 🔥<br>⬆️ DU4 (Mingmen) 🔥<br>⬆️ ST36 (Zusanli) 🔥<br>⬆️ BL23 (Shenshu) 🔥',
    singlePoint: '⬆️ DU4 (Mingmen) 🔥'
  }]
}, {
  name: 'Moisture',
  id: 'moisture',
  findings: [{
    detail: 'Too wet',
    pattern: 'Yang Def/Damp',
    meaning: 'Damp or Yang deficient',
    treatmentPoints: '⬆️ CV4 (Guanyuan) 🔥<br>⬆️ SP9 (Yinlingquan)<br>⬆️ ST36 (Zusanli) 🔥<br>⬆️ BL20 (Pishu) 🔥',
    singlePoint: '⬆️ SP9 (Yinlingquan)'
  }, {
    detail: 'Too dry',
    pattern: 'Heat/Yin deficiency',
    meaning: 'Heat, Yin deficiency',
    treatmentPoints: '⬆️ KI3 (Taixi)<br>⬆️ SP6 (Sanyinjiao)<br>⬆️ ST36 (Zusanli)<br>⬇️ LI11 (Quchi)',
    singlePoint: '⬆️ KI3 (Taixi)'
  }, {
    detail: 'Sticky',
    pattern: 'Damp/Phlegm retention',
    meaning: 'Damp/phlegm retention',
    treatmentPoints: '⬆️ SP9 (Yinlingquan)<br>⬆️ ST40 (Fenglong)<br>⬆️ CV12 (Zhongwan)<br>⬆️ BL20 (Pishu) 🔥',
    singlePoint: '⬆️ ST40 (Fenglong)'
  }]
}, {
  name: 'Sublingual Veins',
  id: 'sublingual',
  findings: [{
    detail: 'Distended/purple veins',
    pattern: 'Blood stasis',
    meaning: 'Circulation problem',
    treatmentPoints: '⬇️ SP10 (Xuehai)<br>⬇️ PC6 (Neiguan)<br>⬇️ LV3 (Taichong)',
    singlePoint: '⬇️ SP10 (Xuehai)'
  }, {
    detail: 'Blue/purple',
    pattern: 'Qi stagnation, cold',
    meaning: 'Impaired flow, cold',
    treatmentPoints: '⬇️ LV3 (Taichong)<br>⬇️ PC6 (Neiguan)<br>⬆️ CV4 (Guanyuan) 🔥',
    singlePoint: '⬇️ LV3 (Taichong)'
  }, {
    detail: 'Thin, pale veins',
    pattern: 'Qi & Blood deficiency',
    meaning: 'Weak circulation',
    treatmentPoints: '⬆️ SP6 (Sanyinjiao)<br>⬆️ ST36 (Zusanli)<br>⬆️ BL17 (Geshu) 🔥<br>⬆️ CV6 (Qihai)',
    singlePoint: '⬆️ ST36 (Zusanli)'
  }, {
    detail: 'Tortuous / nodular veins',
    pattern: 'Chronic stasis',
    meaning: 'Chronic stagnation/disease',
    treatmentPoints: '⬇️ SP10 (Xuehai)<br>⬇️ LV3 (Taichong)<br>⬇️ PC6 (Neiguan)<br>⬇️ SP4 (Gongsun)',
    singlePoint: '⬇️ SP10 (Xuehai)'
  }, {
    detail: 'No obvious veins',
    pattern: 'Normal',
    meaning: 'Healthy circulation',
    treatmentPoints: 'No treatment needed<br>Maintain health',
    singlePoint: 'N/A'
  }]
}];
export function TongueReference() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFinding, setSelectedFinding] = useState<{
    category: string;
    finding: Finding;
  } | null>(null);
  const highlightText = (text: string, search: string) => {
    if (!search) return text;
    const regex = new RegExp(`(${search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    return text.replace(regex, '<mark class="bg-yellow-200 px-1 rounded">$1</mark>');
  };
  const filteredCategories = categories.map(category => ({
    ...category,
    findings: category.findings.filter(finding => {
      const term = searchTerm.toLowerCase();
      return !term || finding.detail.toLowerCase().includes(term) || finding.pattern.toLowerCase().includes(term) || finding.meaning.toLowerCase().includes(term) || category.name.toLowerCase().includes(term) || finding.treatmentPoints.toLowerCase().includes(term) || finding.singlePoint.toLowerCase().includes(term);
    })
  })).filter(category => category.findings.length > 0);
  const hasResults = filteredCategories.length > 0;
  return <div className="space-y-6" data-id="element-87">
      {/* Header */}
      <div className="bg-gradient-to-r from-purple-600 to-purple-800 text-white p-8 rounded-lg shadow-md" data-id="element-88">
        <h2 className="text-3xl font-bold mb-2" data-id="element-89">
          🌿 TCM Tongue Diagnosis Interactive Table
        </h2>
        <p className="text-purple-100" data-id="element-90">
          Comprehensive reference for Traditional Chinese Medicine tongue
          diagnosis patterns and interpretations
        </p>
      </div>
      {/* Search */}
      <div className="sticky top-0 bg-white z-10 p-4 rounded-lg shadow-md border border-gray-200" data-id="element-91">
        <div className="relative max-w-2xl mx-auto" data-id="element-92">
          <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Search across all categories..." className="w-full px-4 py-3 pr-24 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all" data-id="element-93" />
          {searchTerm && <button onClick={() => setSearchTerm('')} className="absolute right-3 top-1/2 -translate-y-1/2 px-4 py-1 bg-gradient-to-r from-purple-600 to-purple-800 text-white rounded-md hover:opacity-90 transition-opacity text-sm font-medium" data-id="element-94">
              Clear
            </button>}
        </div>
      </div>
      {/* Categories */}
      {hasResults ? filteredCategories.map(category => <div key={category.id} className="space-y-4" data-id="element-95">
            <div className="bg-gradient-to-r from-purple-600 to-purple-800 text-white p-5 rounded-lg shadow-sm" data-id="element-96">
              <h3 className="text-xl font-bold" data-id="element-97">{category.name}</h3>
            </div>
            <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-98">
              <table className="w-full bg-white" data-id="element-99">
                <thead className="bg-purple-50" data-id="element-100">
                  <tr data-id="element-101">
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b-2 border-purple-200" data-id="element-102">
                      Category
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b-2 border-purple-200" data-id="element-103">
                      Detail/Feature
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b-2 border-purple-200" data-id="element-104">
                      TCM Pattern
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b-2 border-purple-200" data-id="element-105">
                      Condition/Meaning
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b-2 border-purple-200 min-w-[200px]" data-id="element-106">
                      Pattern Treatment Points
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b-2 border-purple-200 min-w-[180px]" data-id="element-107">
                      Most Effective Single Point
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-108">
                  {category.findings.map((finding, idx) => <tr key={idx} onClick={() => setSelectedFinding({
              category: category.name,
              finding
            })} className="cursor-pointer hover:bg-purple-50 transition-colors border-b border-gray-100 last:border-b-0" data-id="element-109">
                      <td className="px-4 py-3 text-sm" dangerouslySetInnerHTML={{
                __html: highlightText(category.name, searchTerm)
              }} data-id="element-110" />
                      <td className="px-4 py-3 text-sm" dangerouslySetInnerHTML={{
                __html: highlightText(finding.detail, searchTerm)
              }} data-id="element-111" />
                      <td className="px-4 py-3 text-sm" dangerouslySetInnerHTML={{
                __html: highlightText(finding.pattern, searchTerm)
              }} data-id="element-112" />
                      <td className="px-4 py-3 text-sm" dangerouslySetInnerHTML={{
                __html: highlightText(finding.meaning, searchTerm)
              }} data-id="element-113" />
                      <td className="px-4 py-3 text-sm leading-relaxed" dangerouslySetInnerHTML={{
                __html: highlightText(finding.treatmentPoints, searchTerm)
              }} data-id="element-114" />
                      <td className="px-4 py-3 text-sm font-medium" dangerouslySetInnerHTML={{
                __html: highlightText(finding.singlePoint, searchTerm)
              }} data-id="element-115" />
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>) : <div className="text-center py-12 text-gray-500" data-id="element-116">
          <p className="text-lg" data-id="element-117">
            No findings match your search. Try different keywords.
          </p>
        </div>}
      {/* Modal */}
      {selectedFinding && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" onClick={() => setSelectedFinding(null)} data-id="element-118">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl animate-[slideIn_0.3s_ease]" onClick={e => e.stopPropagation()} data-id="element-119">
            <div className="bg-gradient-to-r from-purple-600 to-purple-800 text-white p-6 rounded-t-lg flex justify-between items-center" data-id="element-120">
              <h3 className="text-2xl font-bold" data-id="element-121">Diagnostic Detail</h3>
              <button onClick={() => setSelectedFinding(null)} className="w-9 h-9 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full flex items-center justify-center text-2xl transition-colors" data-id="element-122">
                &times;
              </button>
            </div>
            <div className="p-6 space-y-5" data-id="element-123">
              <div className="pb-5 border-b border-gray-200" data-id="element-124">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2" data-id="element-125">
                  Category
                </div>
                <div className="text-lg font-medium text-gray-900" data-id="element-126">
                  {selectedFinding.category}
                </div>
              </div>
              <div className="pb-5 border-b border-gray-200" data-id="element-127">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2" data-id="element-128">
                  Detail / Feature
                </div>
                <div className="text-lg font-medium text-gray-900" data-id="element-129">
                  {selectedFinding.finding.detail}
                </div>
              </div>
              <div className="pb-5 border-b border-gray-200" data-id="element-130">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2" data-id="element-131">
                  TCM Pattern / State
                </div>
                <div className="text-lg font-medium text-gray-900" data-id="element-132">
                  {selectedFinding.finding.pattern}
                </div>
              </div>
              <div className="pb-5 border-b border-gray-200" data-id="element-133">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2" data-id="element-134">
                  Condition / Meaning
                </div>
                <div className="text-lg font-medium text-gray-900" data-id="element-135">
                  {selectedFinding.finding.meaning}
                </div>
              </div>
              <div className="pb-5 border-b border-gray-200" data-id="element-136">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2" data-id="element-137">
                  Pattern Treatment Points
                </div>
                <div className="text-lg font-medium text-gray-900 leading-relaxed" dangerouslySetInnerHTML={{
              __html: selectedFinding.finding.treatmentPoints
            }} data-id="element-138" />
              </div>
              <div data-id="element-139">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2" data-id="element-140">
                  Most Effective Single Point
                </div>
                <div className="text-xl font-semibold text-gray-900" dangerouslySetInnerHTML={{
              __html: selectedFinding.finding.singlePoint
            }} data-id="element-141" />
              </div>
            </div>
          </div>
        </div>}
    </div>;
}